(function($) {

    $.fn.notification = function() {

        var elem = $(this),
            closeButton = elem.find('.js-notification__close'),
            settings = {
                autoCloseTimeout: 5000,
                transitionTimeout: 1000,
                activeClass: 'is-active',
                persistentClass: 'is-persistent'
            };

        var init = function() {

            // This is a persistent error so we have no business being here
            if(elem.hasClass(settings.persistentClass)) {
                return;
            }

            // Auto remove elem on timeout
            var hideTimeout = setTimeout(function() {
                                    removeElem();
                                }, settings.autoCloseTimeout);

            // Bind hide to click
            closeButton.on('click', function(evt) {
                evt.preventDefault();

                clearTimeout(hideTimeout);
                removeElem();
            });

        },

        removeElem = function() {

            // Remove active class to visually hide
            elem.removeClass(settings.activeClass);

            // Remove the element alltogether
            setTimeout(function() {
                elem.remove();
            }, settings.transitionTimeout);
        }

        init();
        return this;
    };
}($));
